// Session 34 · P1 — v2 booking Cancel page.
// User abandoned Stripe Checkout. No payment was captured. Our TTL sweeper
// will release the hold automatically within a few minutes.
import { Link, useSearchParams } from "react-router-dom";
import AppShell from "../components/AppShell";

export default function BookingV2Cancel() {
  const [sp] = useSearchParams();
  const reqId = sp.get("req_id");
  return (
    <AppShell>
      <div className="rec-hero" style={{ paddingTop: 40, paddingBottom: 24 }}>
        <div className="rec-container" style={{ maxWidth: 720 }}>
          <div className="m-callout" data-testid="v2-cancel-message">
            <div style={{ letterSpacing: 0.16, textTransform: "uppercase", fontSize: 11, color: "rgba(27,35,64,0.55)" }}>Booking not completed</div>
            <h2 style={{ fontFamily: "Georgia,serif", fontSize: 30, margin: "8px 0 6px", color: "var(--m-navy)" }}>No charge made.</h2>
            <p style={{ fontSize: 14.5, lineHeight: 1.7, color: "rgba(27,35,64,0.85)" }}>
              You canceled Stripe Checkout before completing payment. The workspace
              slot has been released — no card was charged. Feel free to try again
              or browse other workspaces.
            </p>
            {reqId && (
              <p className="m-muted small" style={{ marginTop: 12 }}>
                Reference: <code>{reqId}</code>
              </p>
            )}
          </div>
          <div style={{ marginTop: 24, display: "flex", gap: 12, flexWrap: "wrap" }}>
            <Link to="/spaces" className="m-btn-gold" data-testid="v2-cancel-browse">Browse workspaces</Link>
            <Link to="/" className="m-btn-ghost" data-testid="v2-cancel-home">Return home</Link>
          </div>
        </div>
      </div>
    </AppShell>
  );
}
